export enum ValidatorsActions {
    SET_ACTIVE_VALIDATOR = "setActiveValidator",
    SET_VALIDATORS = "setSelectedValidators",
    REMOVE_DATA = "removeValidatorsData",
    ACCEPT_VALIDATOR = "acceptValidator",
    CANCEL_VALIDATOR = "cancelValidator",
    RELOAD = "reloadValidators",
  }